import { EmptyTextData } from 'library/types';

const usTerritoriesCountryCodes = ['AS', 'GU', 'MP', 'PR', 'VI'];

export const getShortLocationFormat = (
	country: EmptyTextData,
	city: EmptyTextData
) => (city ? `${city}, ${country || ''}` : country || '');

export const isUSTerritory = (countryCode: EmptyTextData) =>
	usTerritoriesCountryCodes.includes(countryCode || '');
